import isEmpty from './isEmpty'
import 'animate.css'

export const highlightFormError = () => {
  function elementInView (element) {
    const rect = element.getBoundingClientRect()
    const yInView = rect.top < window.innerHeight && rect.bottom > 0
    const xInView = rect.left < window.innerWidth && rect.right > 0
    return yInView && xInView
  }

  const animateCSS = (el, animationName) =>
    new Promise((resolve, reject) => {
      if (el) {
        for (let v of el instanceof NodeList ? el : [el]) {
          v.classList.add('animate__animated', animationName)

          function handleAnimationEnd () {
            v.classList.remove('animate__animated', animationName)
            v.removeEventListener('animationend', handleAnimationEnd)
            resolve()
          }

          v.addEventListener('animationend', handleAnimationEnd)
        }
      } else {
        reject()
      }
    })

  //is-error类名需要异步才能获取到
  setTimeout(() => {
    const errFormItems = document.querySelectorAll('.el-form .el-form-item.is-error')

    //视图滚动至校验失败的第一个表单项
    if (errFormItems[0] && !elementInView(errFormItems[0])) {
      errFormItems[0].scrollIntoView({
        behavior: 'smooth'
      })
    }
    //对所有校验失败的表单项产生震动效果
    animateCSS(errFormItems, 'animate__headShake').catch(e => {
      console.warn(e)
    })
  }, 0)
}

const required = {
  required: true,
  trigger: 'blur',
  //message: '必填项',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (isEmpty(value)) {
      errInfo = '必填项'
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

const coord = type => {
  if (!['lng', 'lat'].includes(type)) {
    throw Error('coord__方法的参数只能是lng或lat')
  }

  const validateRange = new Map([
    ['lng', value => {
      value = Number(value)
      if (value > 180 || value < -180) {
        return '经度的范围为[-180, 180]'
      }
    }], ['lat', value => {
      value = Number(value)
      if (value > 90 || value < -90) {
        return '纬度的范围为[-90, 90]'
      }
    }]
  ]).get(type)

  return {
    required: true,
    trigger: 'blur',
    validator: (rule, value, callback) => {
      //兼容非element场景调用
      if (typeof rule !== 'object' && value === undefined && callback === undefined) {
        value = rule
      }

      let errInfo = ''
      if (isEmpty(value)) {
        errInfo = '必填项'
      } else if (/^-?\d+\.\d+$/.test(value)) {
        errInfo = validateRange(value)
        let decimalPart = String(value).split('.')[1]
        if (decimalPart.length > 6) {
          errInfo = '最多6位小数'
        }
      } else if ((/^-?\d+$/).test(value)) {
        errInfo = validateRange(value)
      } else {
        errInfo = '格式不正确'
      }

      callback && callback(errInfo ? new Error(errInfo) : undefined)
      return errInfo
    }
  }
}

//手机
const phone = {
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (!isEmpty(value) && !/^1\d{10}$/.test(value)) {
      errInfo = '格式不正确'
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

//身份证
const idCard = {
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''

    if (!isEmpty(value)) {
      // 加权因子
      let weight_factor = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2]
      // 校验码
      let check_code = ['1', '0', 'X', '9', '8', '7', '6', '5', '4', '3', '2']

      let code = value + ''
      let last = value[17] //最后一位

      let seventeen = code.substring(0, 17)

      // ISO 7064:1983.MOD 11-2
      // 判断最后一位校验码是否正确
      let arr = seventeen.split('')
      let len = arr.length
      let num = 0
      for (let i = 0; i < len; i++) {
        num = num + arr[i] * weight_factor[i]
      }

      // 获取余数
      let resisue = num % 11
      let last_no = check_code[resisue]

      // 格式的正则
      // 正则思路
      /*
      第一位不可能是0
      第二位到第六位可以是0-9
      第七位到第十位是年份，所以七八位为19或者20
      十一位和十二位是月份，这两位是01-12之间的数值
      十三位和十四位是日期，是从01-31之间的数值
      十五，十六，十七都是数字0-9
      十八位可能是数字0-9，也可能是X
      */
      let idcard_patter = /^[1-9][0-9]{5}([1][9][0-9]{2}|[2][0][0|1][0-9])([0][1-9]|[1][0|1|2])([0][1-9]|[1|2][0-9]|[3][0|1])[0-9]{3}([0-9]|[X])$/

      // 判断格式是否正确
      let format = idcard_patter.test(value)

      // 返回验证结果，校验码和格式同时正确才算是合法的身份证号码
      if (!(last === last_no && format)) {
        errInfo = '格式不正确'
      }
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

//座机
const tel = (multiple = true) => {
  const regex = multiple ? /^[+\-;\d]*$/ : /^[+\-\d]*$/
  const length = multiple ? 50 : 20
  return {
    trigger: 'blur',
    validator: (rule, value, callback) => {
      //兼容非element场景调用
      if (typeof rule !== 'object' && value === undefined && callback === undefined) {
        value = rule
      }

      let errInfo = ''
      if (!isEmpty(value)) {
        if (value.length > length) {
          errInfo = length + '个字符以内'
        } else if (!regex.test(value)) {
          errInfo = '格式不正确' + (multiple ? '，如有多个请用英文分号隔开' : '')
        }
      }

      callback && callback(errInfo ? new Error(errInfo) : undefined)
      return errInfo
    }
  }
}

const email = {
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (!isEmpty(value) && !/^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/.test(value)) {
      errInfo = '格式不正确'
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

//账号
const account = {
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (!/^[A-Za-z\d]+$/.test(value)) {
      errInfo = '需为数字或字母'
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

const len = (max, min) => {
  if (isNaN(max)) {
    throw Error('len__方法的第一个参数必填，且需为Number类型')
  }

  return {
    trigger: 'blur',
    validator: (rule, value, callback) => {
      //兼容非element场景调用
      if (typeof rule !== 'object' && value === undefined && callback === undefined) {
        value = rule
      }

      let errInfo = ''
      if (!isEmpty(value)) {
        if (value.length > max) {
          errInfo = max + '个字符以内'
        } else if (min && value.length < min) {
          errInfo = min + '个字符以上'
        }
      }

      callback && callback(errInfo ? new Error(errInfo) : undefined)
      return errInfo
    }
  }
}

const integer = ({
  required,
  len,
  maxLen,
  minLen,
  min,
  max,
  lessThan,
  greaterThan,
} = {}) => {
  return {
    trigger: 'blur',
    required,
    validator: (rule, value, callback) => {
      //兼容非element场景调用
      if (typeof rule !== 'object' && value === undefined && callback === undefined) {
        value = rule
      }

      let errInfo = ''
      if (required && isEmpty(value)) {
        errInfo = '必填项'
      } else if (value) {
        const numberValue = Number(value)
        const stringValue = String(value)
        switch (true) {
          case (!/^-?\d*$/.test(value)):
            errInfo = '需为整数'
            break
          case (!isEmpty(min) && numberValue < min) :
            errInfo = '不能小于' + min
            break
          case (!isEmpty(max) && numberValue > max) :
            errInfo = '不能大于' + max
            break
          case (!isEmpty(greaterThan) && numberValue <= greaterThan) :
            errInfo = '需大于' + greaterThan
            break
          case (!isEmpty(lessThan) && numberValue >= lessThan) :
            errInfo = '需小于' + lessThan
            break
          case (!isEmpty(minLen) && stringValue.length < minLen) :
            errInfo = minLen + '位以上'
            break
          case (!isEmpty(maxLen) && stringValue.length > maxLen) :
            errInfo = maxLen + '位以内'
            break
          case (!isEmpty(len) && stringValue.length !== len) :
            errInfo = '长度需为' + len + '位'
        }
      }

      callback && callback(errInfo ? new Error(errInfo) : undefined)
      return errInfo
    }
  }
}

const decimal = ({
  required,
  allowInt = true,
  min,
  max,
  lessThan,
  greaterThan,
  decimalPlaces,
  minDecimalPlaces,
  maxDecimalPlaces,
} = {}) => {
  return {
    trigger: 'blur',
    required,
    validator: (rule, value, callback) => {
      //兼容非element场景调用
      if (typeof rule !== 'object' && value === undefined && callback === undefined) {
        value = rule
      }

      let errInfo = ''
      if (required && isEmpty(value)) {
        errInfo = '必填项'
      } else if (value) {
        const numberValue = Number(value)
        const stringValue = String(value)
        switch (true) {
          case (!/(^\d+\.?\d+$)|(^\d+$)/.test(value)) :
            errInfo = '需为数字'
            break
          case (!isEmpty(min) && numberValue < min) :
            errInfo = '不能小于' + min
            break
          case (!isEmpty(max) && numberValue > max) :
            errInfo = '不能大于' + max
            break
          case (!isEmpty(greaterThan) && numberValue <= greaterThan) :
            errInfo = '需大于' + greaterThan
            break
          case (!isEmpty(lessThan) && numberValue >= lessThan) :
            errInfo = '需小于' + lessThan
            break
          default :
            const decimalPart = stringValue.split('.')
            if (!allowInt && isEmpty(decimalPart[1])) {
              errInfo = '需为小数'
            }
            if (!isEmpty(decimalPlaces)) {
              switch (true) {
                case decimalPlaces < 0:
                  throw Error('decimalPlaces不能小于0')
                case decimalPlaces === 0:
                  if (allowInt && !isEmpty(decimalPart[1])) {
                    errInfo = '需为整数'
                  }
                  break
                default:
                  if (decimalPart[1]?.length !== decimalPlaces) {
                    errInfo = '小数位数需为' + decimalPlaces + '位'
                  }
              }
            } else if (!isEmpty(maxDecimalPlaces)) {
              if (decimalPart[1]?.length > maxDecimalPlaces) {
                errInfo = '最多' + maxDecimalPlaces + '位小数'
              }
            } else if (!isEmpty(minDecimalPlaces)) {
              if (decimalPart[1]?.length < minDecimalPlaces) {
                errInfo = '最少' + maxDecimalPlaces + '位小数'
              }
            }
        }
      }

      callback && callback(errInfo ? new Error(errInfo) : undefined)
      return errInfo
    }
  }
}

const pwd = {
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (!isEmpty(value)) {
      if (value.length < 8 || value.length > 16) {
        errInfo = '长度需为8~16位'
      } else if (!/^[a-zA-Z\d_()`·*&^%$#@!~{}|:"<>?\[\]\\\-;',\.\/]+$/.test(value)) {
        errInfo = '需为字母/数字或常见的特殊符号'
      } else if (!/[a-zA-Z]/.test(value) || !/\d/.test(value)) {
        errInfo = '至少包含字母和数字'
      }
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

const verificationCode = {
  required: true,
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (isEmpty(value)) {
      errInfo = '必填项'
    } else if (value.length !== 5) {
      errInfo = '长度不正确'
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

const version = {
  trigger: 'blur',
  validator: (rule, value, callback) => {
    //兼容非element场景调用
    if (typeof rule !== 'object' && value === undefined && callback === undefined) {
      value = rule
    }

    let errInfo = ''
    if (!isEmpty(value) && !/^\d{1,3}\.\d{1,3}\.\d{1,7}$/.test(value)) {
      errInfo = '格式不正确'
    }

    callback && callback(errInfo ? new Error(errInfo) : undefined)
    return errInfo
  }
}

export default {
  coord,
  required,
  integer,
  decimal,
  pwd,
  len,
  phone,
  tel,
  email,
  account,
  verificationCode,
  version,
  idCard,
}
